import React, { useEffect, useState } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Grid,
  Toolbar,
  InputAdornment,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import { RxActivityLog } from "react-icons/rx";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";
import Admin from "../../components/auth/Admin";
import Staff from "../../actions/staff";
import AddStaffForm from "../../components/forms/AddStaff";
import Popup from "../../components/customHelpers/Popup";
import produce from "immer";
import ChangePassword from "../../components/forms/updatePassword";
import { MdModeEdit } from "react-icons/md";
import ActivityLog from "../../components/activityLog";
import Layout from "../../components/layout/Layout";
import { isAuth } from "../../actions/auth";

const headCells = [
  { id: "fullName", label: "Full Name" },
  { id: "email", label: "Email" },
  { id: "phoneNo", label: "Phone Number" },
  { id: "username", label: "UserName" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const StaffPage = () => {
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllStaff, deleteStaff } = Staff();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [staffId, setStaffId] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [openActivity, setOpenActivity] = useState(false);
  const [edite, setEdit] = useState(false);
  const [staff, setStaffs] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;

  useEffect(() => {
    getAllStaffs();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const getAllStaffs = () => {
    setValues({ ...values, loading: true });
    viewAllStaff().then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err, type: "error" });
      } else if (data.staffs) {
        setValues({ ...values, loading: false });
        setStaffs(data.staffs);
      }
    });
  };

  const onDelete = (Id) => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    deleteStaff(Id).then((data) => {
      if (data.err) {
        NotifyMessage({ message: data.err || data.message, type: "error" });
        setValues({ ...values, loading: false });
      } else {
        NotifyMessage({ message: data.message, type: "success" });
        setValues({ ...values, reload: !reload });
        setStaffs(
          produce(staff, (draft) => {
            const index = staff.findIndex((staff) => staff.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(staff, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["fullName", "email"];
        if (target.value === "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Staffs
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search Staff"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
            <Controls.Button
              text="Add Staff"
              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                setOpenPopup(true);
                setRecordForEdit(null);
                setEdit(false);
              }}
            />
          </Toolbar>

          <Grid container>
            <Grid item xs={12}>
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.fullName}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phoneNo}</TableCell>
                            <TableCell>{item.username}</TableCell>

                            <TableCell>
                            {(isAuth().id !== item.id && item.role !== "admin") && (
                                <Controls.ActionButton
                                  color="secondary"
                                  title="Delete"
                                  onClick={() => {
                                    setConfirmDialog({
                                      isOpen: true,
                                      title:
                                        "Are you sure to delete this Staff?",
                                      subTitle: "You can't undo this operation",
                                      onConfirm: () => {
                                        onDelete(item.id);
                                      },
                                    });
                                  }}
                                >
                                  <MdOutlineDelete fontSize="medium" />
                                </Controls.ActionButton>
                              )}
                              <Controls.ActionButton
                                color="primary"
                                title="Update"
                                onClick={() => {
                                  setOpenPopup(true);
                                  setRecordForEdit(item);
                                  setEdit(true);
                                }}
                              >
                                <FiEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(`/staff-detail/${item.id}`);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Change Password"
                                onClick={() => {
                                  setOpenChangePassword(true);
                                  setStaffId(item.id);
                                }}
                              >
                                <MdModeEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Activity Log"
                                onClick={() => {
                                  setOpenActivity(true);
                                  setStaffId(item.id);
                                }}
                              >
                                <RxActivityLog fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Staff Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddStaffForm
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setStaffs={setStaffs}
            getAllStaffs={getAllStaffs}
            edite={edite}
          />
        </Popup>
        <Popup
          title="Change Password"
          openPopup={openChangePassword}
          setOpenPopup={setOpenChangePassword}
        >
          <ChangePassword
            admin="true"
            id={staffId}
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenChangePassword}
          />
        </Popup>
        <Popup
          title="Activity Log"
          openPopup={openActivity}
          setOpenPopup={setOpenActivity}
        >
          <ActivityLog
            id={staffId}
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenActivity}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default StaffPage;
